import { __read, __values } from "tslib";
import { SortOrder, UNLIMITED } from '@tencent/memoire-core';
var RawQueryBuilder = /** @class */ (function () {
    function RawQueryBuilder(aliasMap) {
        if (aliasMap === void 0) { aliasMap = new Map(); }
        this.query = {
            offset: 0,
            limit: undefined,
            order: undefined,
            whereClauses: [],
        };
        this.aliasMap = aliasMap;
    }
    RawQueryBuilder.fromRawQuery = function (rawQuery, aliasMap) {
        var e_1, _a;
        if (aliasMap === void 0) { aliasMap = new Map(); }
        var builder = new RawQueryBuilder(aliasMap);
        var offset = rawQuery.offset, limit = rawQuery.limit, order = rawQuery.order, whereClauses = rawQuery.whereClauses;
        builder.setOffset(offset);
        builder.setLimit(limit);
        if (order) {
            builder.setOrderBy(order.path, order.type);
        }
        try {
            for (var whereClauses_1 = __values(whereClauses), whereClauses_1_1 = whereClauses_1.next(); !whereClauses_1_1.done; whereClauses_1_1 = whereClauses_1.next()) {
                var clause = whereClauses_1_1.value;
                builder.addWhereClause(clause);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (whereClauses_1_1 && !whereClauses_1_1.done && (_a = whereClauses_1.return)) _a.call(whereClauses_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return builder;
    };
    RawQueryBuilder.prototype.setOffset = function (offset) {
        this.query.offset = offset;
    };
    RawQueryBuilder.prototype.setLimit = function (limit) {
        this.query.limit = limit;
    };
    RawQueryBuilder.prototype.setRange = function (start, end) {
        if (start === void 0) { start = 0; }
        this.query.offset = start;
        this.query.limit = end !== UNLIMITED ? Math.max(0, end - start) : UNLIMITED;
    };
    RawQueryBuilder.prototype.setOrderBy = function (path, type) {
        this.query.order = { path: path, type: type || SortOrder.ASCENDING };
    };
    RawQueryBuilder.prototype.addWhereClause = function (whereClause) {
        var e_2, _a;
        var _b;
        if (!this.isValidWhereClause(whereClause))
            return;
        var finalClause = {};
        try {
            for (var _c = __values(Object.entries(whereClause)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), field = _e[0], predicate = _e[1];
                if (predicate === undefined)
                    continue;
                var alias = (_b = this.aliasMap.get(field)) !== null && _b !== void 0 ? _b : field;
                finalClause[alias] = predicate;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.query.whereClauses.push(finalClause);
    };
    RawQueryBuilder.prototype.clone = function (aliasMap) {
        if (aliasMap === void 0) { aliasMap = this.aliasMap; }
        return RawQueryBuilder.fromRawQuery(this.query, aliasMap);
    };
    RawQueryBuilder.prototype.build = function () {
        return this.query;
    };
    RawQueryBuilder.prototype.isValidWhereClause = function (clause) {
        return !!clause && Object.keys(clause).length >= 0;
    };
    return RawQueryBuilder;
}());
export default RawQueryBuilder;
//# sourceMappingURL=raw-query-builder.js.map